<div class="create-password-step flex column align-items-center step-layout">
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32">
      <div class="flex column align-items-center gap-16">
        <span class="typo-title-3">Create Your Password</span>
        <span class="typo-text-2 text-medium text-align-center"
          >This password unlocks your wallet on this device.</span
        >
      </div>
      <div class="password-notice">
        <kc-icon
          iconClass="icon-info"
          [size]="'sm'"
          color="var(--warning-color, #FFB800)"
        />
        <p class="password-notice__message typo-text-3">
          <span class="password-notice__label">Important:</span>
          This password encrypts your wallet on this device. It cannot be
          recovered if lost. Save it somewhere secure.
        </p>
      </div>

      <form
        class="create-password-form flex column gap-16 full-width align-items-stretch align-self-stretch"
        [formGroup]="passwordForm"
        (ngSubmit)="onSubmit()"
      >
        <kc-input
          class="full-width"
          formControlName="password"
          [infoLabel]="{ label: 'Enter your password' }"
          [placeholder]="'Enter password'"
          [type]="passwordType()"
          [isValid]="!isInvalid('password')"
          (keydown.enter)="onSubmit()"
        >
          <div (click)="togglePwVisibility()" class="clickable" rightSideSlot>
            <kc-icon iconClass="{{ passwordIcon() }}" [size]="'xs'" />
          </div>
        </kc-input>
        @if (isInvalid("password") && getPasswordErrorMessage()) {
          <span class="kc-input-error-text">{{
            getPasswordErrorMessage()
          }}</span>
        }
        <kc-input
          class="full-width"
          formControlName="confirmPassword"
          [infoLabel]="{ label: 'Confirm your password' }"
          [placeholder]="'Confirm password'"
          [type]="passwordConfirmType()"
          [isValid]="!isInvalid('confirmPassword')"
          (keydown.enter)="onSubmit()"
        >
          <div
            (click)="toggleConfirmPwVisibility()"
            class="clickable"
            rightSideSlot
          >
            <kc-icon [iconClass]="passwordConfirmIcon()" [size]="'xs'" />
          </div>
        </kc-input>
        @if (isInvalid("confirmPassword") && getConfirmPasswordErrorMessage()) {
          <span class="kc-input-error-text">{{
            getConfirmPasswordErrorMessage()
          }}</span>
        }
      </form>
    </div>
  </div>

  <div class="step-layout__buttons">
    <kc-button
      [isFullWidth]="true"
      type="submit"
      [text]="'Continue'"
      [isDisabled]="!passwordForm.valid"
      (buttonClick)="onSubmit()"
    />
  </div>
</div>
